/**
 * @generated SignedSource<<e393fd84513a166cd962a1a39f17dcc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsDepartureLocationListPageQuery$variables = {};
export type SettingsDepartureLocationListPageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DepartureLocationsList_data">;
};
export type SettingsDepartureLocationListPageQuery = {
  response: SettingsDepartureLocationListPageQuery$data;
  variables: SettingsDepartureLocationListPageQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsDepartureLocationListPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "DepartureLocationsList_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SettingsDepartureLocationListPageQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 2147483647
          }
        ],
        "concreteType": "DepartureLocationConnection",
        "kind": "LinkedField",
        "name": "departureLocations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DepartureLocationEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DepartureLocation",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "deletable",
                        "storageKey": null
                      }
                    ],
                    "type": "Entity",
                    "abstractKey": "__isEntity"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "total",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": "departureLocations(first:2147483647)"
      }
    ]
  },
  "params": {
    "cacheID": "b7e6f29bd2867d5a023d6f14e978bd60",
    "id": null,
    "metadata": {},
    "name": "SettingsDepartureLocationListPageQuery",
    "operationKind": "query",
    "text": "query SettingsDepartureLocationListPageQuery {\n  ...DepartureLocationsList_data\n}\n\nfragment DepartureLocationListRow_departureLocation on DepartureLocation {\n  id\n  name\n  ...SortableEntityTableRow_entity\n}\n\nfragment DepartureLocationsList_data on Query {\n  departureLocations(first: 2147483647) {\n    edges {\n      node {\n        id\n        ...DepartureLocationListRow_departureLocation\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment SortableEntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  ...EntityTableRow_entity\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};

(node as any).hash = "c4ff3002d79a125f7dcbe166df646077";

export default node;
